import { render, staticRenderFns } from "./IconMapMarker.vue?vue&type=template&id=132f582a"
import script from "./IconMapMarker.vue?vue&type=script&lang=js"
export * from "./IconMapMarker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports